module.exports = [
	{
		"id": 45,
		"Jahr": 2014,
		"KreisSort": "Kreis 1",
		"QuarSort": "Rathaus",
		"VeranderungProzent": 140,
		"QuadratmeterPreis": 66528
	},
	{
		"id": 60,
		"Jahr": 2014,
		"KreisSort": "Kreis 1",
		"QuarSort": "Hochschulen",
		"VeranderungProzent": 140,
		"QuadratmeterPreis": 66528
	},
	{
		"id": 75,
		"Jahr": 2014,
		"KreisSort": "Kreis 1",
		"QuarSort": "Lindenhof",
		"VeranderungProzent": 140,
		"QuadratmeterPreis": 66528
	},
	{
		"id": 90,
		"Jahr": 2014,
		"KreisSort": "Kreis 1",
		"QuarSort": "City",
		"VeranderungProzent": 140,
		"QuadratmeterPreis": 66528
	},
	{
		"id": 120,
		"Jahr": 2014,
		"KreisSort": "Kreis 2",
		"QuarSort": "Wollishofen",
		"VeranderungProzent": 46,
		"QuadratmeterPreis": 4755
	},
	{
		"id": 135,
		"Jahr": 2014,
		"KreisSort": "Kreis 2",
		"QuarSort": "Leimbach",
		"VeranderungProzent": 29,
		"QuadratmeterPreis": 2694
	},
	{
		"id": 150,
		"Jahr": 2014,
		"KreisSort": "Kreis 2",
		"QuarSort": "Enge",
		"VeranderungProzent": 86,
		"QuadratmeterPreis": 14252
	},
	{
		"id": 180,
		"Jahr": 2014,
		"KreisSort": "Kreis 3",
		"QuarSort": "Wiedikon",
		"VeranderungProzent": 65,
		"QuadratmeterPreis": 9136
	},
	{
		"id": 195,
		"Jahr": 2014,
		"KreisSort": "Kreis 3",
		"QuarSort": "Friesenberg",
		"VeranderungProzent": 58,
		"QuadratmeterPreis": 6526
	},
	{
		"id": 210,
		"Jahr": 2014,
		"KreisSort": "Kreis 3",
		"QuarSort": "Sihlfeld",
		"VeranderungProzent": 42,
		"QuadratmeterPreis": 14382
	},
	{
		"id": 240,
		"Jahr": 2014,
		"KreisSort": "Kreis 4",
		"QuarSort": "Werd",
		"VeranderungProzent": 4,
		"QuadratmeterPreis": 18182
	},
	{
		"id": 255,
		"Jahr": 2014,
		"KreisSort": "Kreis 4",
		"QuarSort": "Langstrasse",
		"VeranderungProzent": 89,
		"QuadratmeterPreis": 27385
	},
	{
		"id": 270,
		"Jahr": 2014,
		"KreisSort": "Kreis 4",
		"QuarSort": "Hard",
		"VeranderungProzent": 1,
		"QuadratmeterPreis": 13474
	},
	{
		"id": 300,
		"Jahr": 2014,
		"KreisSort": "Kreis 5",
		"QuarSort": "Gewerbeschule",
		"VeranderungProzent": 45,
		"QuadratmeterPreis": 14602
	},
	{
		"id": 315,
		"Jahr": 2014,
		"KreisSort": "Kreis 5",
		"QuarSort": "Escher-Wyss",
		"VeranderungProzent": 28,
		"QuadratmeterPreis": 8552
	},
	{
		"id": 345,
		"Jahr": 2014,
		"KreisSort": "Kreis 6",
		"QuarSort": "Unterstrass",
		"VeranderungProzent": 70,
		"QuadratmeterPreis": 8370
	},
	{
		"id": 360,
		"Jahr": 2014,
		"KreisSort": "Kreis 6",
		"QuarSort": "Oberstrass",
		"VeranderungProzent": 50,
		"QuadratmeterPreis": 8468
	},
	{
		"id": 390,
		"Jahr": 2014,
		"KreisSort": "Kreis 7",
		"QuarSort": "Fluntern",
		"VeranderungProzent": 5,
		"QuadratmeterPreis": 5897
	},
	{
		"id": 405,
		"Jahr": 2014,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hottingen",
		"VeranderungProzent": 20,
		"QuadratmeterPreis": 7685
	},
	{
		"id": 420,
		"Jahr": 2014,
		"KreisSort": "Kreis 7",
		"QuarSort": "Hirslanden",
		"VeranderungProzent": 62,
		"QuadratmeterPreis": 8912
	},
	{
		"id": 435,
		"Jahr": 2014,
		"KreisSort": "Kreis 7",
		"QuarSort": "Witikon",
		"VeranderungProzent": 56,
		"QuadratmeterPreis": 3995
	},
	{
		"id": 465,
		"Jahr": 2014,
		"KreisSort": "Kreis 8",
		"QuarSort": "Seefeld",
		"VeranderungProzent": -9,
		"QuadratmeterPreis": 18088
	},
	{
		"id": 480,
		"Jahr": 2014,
		"KreisSort": "Kreis 8",
		"QuarSort": "Mühlebach",
		"VeranderungProzent": -27,
		"QuadratmeterPreis": 10398
	},
	{
		"id": 495,
		"Jahr": 2014,
		"KreisSort": "Kreis 8",
		"QuarSort": "Weinegg",
		"VeranderungProzent": 13,
		"QuadratmeterPreis": 5497
	},
	{
		"id": 525,
		"Jahr": 2014,
		"KreisSort": "Kreis 9",
		"QuarSort": "Albisrieden",
		"VeranderungProzent": 33,
		"QuadratmeterPreis": 3814
	},
	{
		"id": 540,
		"Jahr": 2014,
		"KreisSort": "Kreis 9",
		"QuarSort": "Altstetten",
		"VeranderungProzent": 83,
		"QuadratmeterPreis": 5029
	},
	{
		"id": 570,
		"Jahr": 2014,
		"KreisSort": "Kreis 10",
		"QuarSort": "Höngg",
		"VeranderungProzent": 33,
		"QuadratmeterPreis": 3980
	},
	{
		"id": 585,
		"Jahr": 2014,
		"KreisSort": "Kreis 10",
		"QuarSort": "Wipkingen",
		"VeranderungProzent": 36,
		"QuadratmeterPreis": 6213
	},
	{
		"id": 615,
		"Jahr": 2014,
		"KreisSort": "Kreis 11",
		"QuarSort": "Affoltern",
		"VeranderungProzent": 56,
		"QuadratmeterPreis": 3144
	},
	{
		"id": 630,
		"Jahr": 2014,
		"KreisSort": "Kreis 11",
		"QuarSort": "Oerlikon",
		"VeranderungProzent": 45,
		"QuadratmeterPreis": 4607
	},
	{
		"id": 645,
		"Jahr": 2014,
		"KreisSort": "Kreis 11",
		"QuarSort": "Seebach",
		"VeranderungProzent": 36,
		"QuadratmeterPreis": 3191
	},
	{
		"id": 675,
		"Jahr": 2014,
		"KreisSort": "Kreis 12",
		"QuarSort": "Saatlen",
		"VeranderungProzent": 19,
		"QuadratmeterPreis": 2780
	},
	{
		"id": 690,
		"Jahr": 2014,
		"KreisSort": "Kreis 12",
		"QuarSort": "Schwamendingen-Mitte",
		"VeranderungProzent": 19,
		"QuadratmeterPreis": 2780
	},
	{
		"id": 705,
		"Jahr": 2014,
		"KreisSort": "Kreis 12",
		"QuarSort": "Hirzenbach",
		"VeranderungProzent": 19,
		"QuadratmeterPreis": 2780
	}
];


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./src/components/svgQuarterMap/data/zhQuarterMapBodenpreise.json
// module id = 161
// module chunks = 0